import { Injectable } from '@angular/core';
import {ParentService} from '../../pages/A2-utils/ParentClass/ParentService';
import {Http} from '@angular/http';
import {constant} from '../../app.constants';

@Injectable()
export class ComplianceService extends ParentService {

  constructor(private http: Http) {
    super();
  }

  getActive() {
    return this.http.get(constant.URL_COMPLIANCE, this.getHeader())
      .map((resp) => resp.json());
  }

  getCompliance(providerid: number) {
    return this.http.get(`${constant.URL_COMPLIANCE}/${providerid}`, this.getHeader())
      .map(resp => resp.json());
  }

  getClaims() {
    return this.http.get(constant.URL_CLAIMS_COUNT, this.getHeader())
      .map((resp) => resp.json());
  }

  getMessage() {
    return this.http.get(constant.URL_MESSAGE_PROVIDER, this.getHeader())
      .map((resp) => resp.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/compliance.service.ts